import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Typography, useMediaQuery, MenuItem, Select } from '@mui/material';
import { useTheme } from '@mui/system';

const SubsectionList = ({ subsectionList, subsection, setSubsection }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(false); // Reset to normal when user scrolls
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleDropdownChange = (event) => {
        setSubsection(event.target.value);
        setIsSticky(true);
    };

    const handleTabClick = (value) => {
        setSubsection(value);
        setIsSticky(true);
    };

    return (
        <Box
            sx={{
                backgroundColor: '#1976D2',
                padding: '10px',
                transition: 'top 0.3s ease-in-out',
                position: isSticky ? 'fixed' : 'relative',
                top: isSticky ? 0 : 'auto',
                width: '100%',
                zIndex: 1000,
            }}
        >
            {isMobile ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', color: '#FFFFFF' }}>
                    <Select
                        value={subsection}
                        onChange={handleDropdownChange}
                        displayEmpty
                        sx={{
                            backgroundColor: '#1976D2',
                            color: '#FFFFFF',
                            width: '100%',
                            outlineColor: "#1976D2",
                            "& .MuiSelect-icon": { color: "#ffffff" },
                        }}
                    >
                        <MenuItem value="" disabled>
                            <Typography sx={{ fontWeight: 'bold' }}>Select a Section</Typography>
                        </MenuItem>
                        {subsectionList.map((section, index) => (
                            <MenuItem key={index} value={section.value}>
                                {section.keyword}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Tabs
                        value={subsection}
                        variant="scrollable"
                        scrollButtons="auto"
                        textColor="inherit"
                        indicatorColor="secondary"
                    >
                        {subsectionList.map((section, index) => (
                            <Tab
                                key={index}
                                label={section.keyword}
                                sx={{ color: '#FFFFFF', fontSize: '17px', fontWeight: 'bold' }}
                                onClick={() => handleTabClick(section.value)}
                                value={section.value}
                            />
                        ))}
                    </Tabs>
                </Box>
            )}
        </Box>
    );
};

export default SubsectionList;
